import {
  useLazyGetTaskDependenciesForMyTaskQuery,
  useLazyGetTaskDependencyQuery,
} from '@crew/apis/task/taskApis'
import { useDataSource } from './useDataSource'

export const useTaskDependencyForMyTaskDataSource = () => {
  const [lazyGetTaskDependenciesForMyTaskQuery] =
    useLazyGetTaskDependenciesForMyTaskQuery()
  const [lazyGetTaskDependencyQuery] = useLazyGetTaskDependencyQuery()

  const taskDependencyDataSource = useDataSource(
    () => ({
      key: 'id',
      load: async (loadOptions) => {
        const response = await lazyGetTaskDependenciesForMyTaskQuery().unwrap()
        return response.taskDependencies
      },
      byKey: async (id) => {
        const response = await lazyGetTaskDependencyQuery({
          taskDependencyId: id,
        }).unwrap()
        return response.taskDependency
      },
    }),
    [lazyGetTaskDependenciesForMyTaskQuery, lazyGetTaskDependencyQuery]
  )

  return taskDependencyDataSource
}
